/**
 * Centralised react-query background-refetch cadences (scale audit F1).
 *
 * ONE knob for every polling `useQuery`, so intervals stay consistent and can be
 * retuned in a single place as tenant count grows — instead of ~130 magic numbers
 * scattered across dozens of files.
 *
 * No `usePolling` hook / visibility listener is needed: react-query already
 * suspends `refetchInterval` while the tab is unfocused (`refetchIntervalInBackground`
 * defaults to `false`), which is exactly the "don't poll a backgrounded kiosk"
 * behaviour — so the call sites only ever want a *number*, and a plain tier
 * constant is the least-machinery way to give them one.
 *
 * Tiers are named by INTENT, not by screen:
 *   live     30s — operational boards / run-pickers where cross-device freshness
 *                  matters within ~30s. This is the TIGHTEST we poll; true live
 *                  dashboards (FloorMonitor, Coldroom wall) are realtime-backstopped
 *                  with a relaxed poll (audit F3), they do not belong here.
 *   standard 60s — the default for ordinary lists.
 *   relaxed  2m  — secondary / background lists.
 *   passive  5m  — passive cross-device feeds where minutes-stale is fine.
 *
 * When tuning for scale, prefer moving a call site to a LONGER tier over editing
 * a number here — but if the whole app must back off, these four values are the
 * only place to change.
 */
export const POLL = {
  live: 30_000,
  standard: 60_000,
  relaxed: 120_000,
  passive: 300_000,
} as const
